import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../services";
import { Globals } from "../../../globals";
import { IngredientViewPage } from "../ingredient-view/ingredient-view/ingredient-view";
import { ProvidersServices } from "../../providers/services";
import { IngredientCreateSelectType } from "../ingredient-create-select-type/ingredient-create-select-type";
import { ExportServices } from "../../services/exportServices";
import { PrintServices } from "../../services/printServices";
import { ConfigurationServices } from '../../configuration/services';
import { ProviderOrderAddPage } from '../../providers/orders/provider-order-add/provider-order-add';
import { HttpClient } from '@angular/common/http';
import { ImportExcelPage } from '../../components/import-excel/import-excel';
import { TranslateService } from '@ngx-translate/core';
import { AdsServices } from '../../ads/services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the IngredientListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-list',
  templateUrl: 'ingredient-list.html',
})
export class IngredientListPage {

  ingredient_type: string = 'basic';
  searchbar_text: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientServices: IngredientsServices,
    public globals: Globals,
    public providersServices: ProvidersServices,
    public exportServices: ExportServices,
    public printServices: PrintServices,
    public http: HttpClient,
    public translate: TranslateService,
    public configurationServices: ConfigurationServices,
    public adsServices: AdsServices) {
    this.globals.GAtrackView('Ingredients', 'Ingredients - List', this.globals.restaurant.email, 'View', 'List ingredients', 'Ingredients', '');
  }

  ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-ingredientes')
    });
    loadingPopup.present();

    // Los tags ya se cargan al inicio de la app en getAllTags()
    this.ingredientServices.getPagesIngredients('basic', 50);
    this.ingredientServices.page_active = 1;

    loadingPopup.dismiss();

    /*if (this.globals.restaurant.tutorial_ingredient == undefined || !this.globals.restaurant.tutorial_ingredient) {
      this.navCtrl.push(IngredientTutorialSlidePage);
    }*/
    this.adsServices.randomProvidersElements();

    this.searchIngredientNode(this.searchbar_text, this.ingredient_type);
  }

  openIngredientCreateSelect() {
    if(this.globals.checkLimitsByLicense('stock','ings_prods') != -1){
      this.navCtrl.push(IngredientCreateSelectType);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }  }


  openIngredientView(ingredient) {
    this.navCtrl.push(IngredientViewPage, {
      ingredient_uid: ingredient.UID,
      ingredient_name: ingredient.name
    });
  }

  async exportIngredients() {
    //Preparar Json para exportar
    var _ingredients = await this.ingredientServices.getIngredients(this.globals.restaurant_uid);

    var data = [];

    for (let ingredient of _ingredients) {
      var _array;
      if (ingredient.sub_recipe) {

        _array = {
          nombre: ingredient.name,
          medida: ingredient.measurement,
          precio: ingredient.price_static,
          proveedor: ingredient.provider_static,
          stock: ingredient.stock,
          alerta_stock: ingredient.stock_alert,
          tags: ingredient.tags_static,
          elaboraicon: ingredient.recipe,
          tiempo: ingredient.time,
          herramientas: ingredient.tools,
          compuesto: 'si',
        };


      } else {

        _array = {
          nombre: ingredient.name,
          medida: ingredient.measurement,
          precio: ingredient.price_static,
          proveedor: ingredient.provider_static,
          stock: ingredient.stock,
          alerta_stock: ingredient.stock_alert,
          tags: ingredient.tags_static,
          compuesto: 'no',
        };
      }

      data.push(_array);
    }

    //
    this.globals.GAtrackView('Ingredients', 'Ingredients - Export ings - View', this.globals.restaurant.email, 'View', 'Export ings', 'Ingredients', '');
    //llamar funcion exportar
    this.exportServices.exportAsExcelFile(data, 'ingredientes');

  }

  openProviderOrderAdd(element) {
    this.navCtrl.push(ProviderOrderAddPage, {
      element: element,
      type: 'ingredient'
    });
  }


  searchIngredientNode(value, type) {
    this.searchbar_text = value; //Guardamos el valor del searchbar
    if (value.target) {
      this.ingredientServices.searchIngredientNode(value, type);
    }
  }

  async paginateNode(type) {
    await this.ingredientServices.getPagesIngredients(type, 50);
    this.ingredient_type = type;
    this.ingredientServices.page_active = 1;
  }
  nextPage() {
    if (this.ingredientServices.page_active < this.ingredientServices.pagesIngredients.length) {
      this.ingredientServices.page_active += 1
    }
    this.ingredientServices.getListIngredientsMinMax();
  }
  previusPage() {
    if (this.ingredientServices.page_active > 1) {
      this.ingredientServices.page_active -= 1;
    }
    this.ingredientServices.getListIngredientsMinMax();
  }
  activePage(number) {
    this.ingredientServices.page_active = number;
    this.ingredientServices.getListIngredientsMinMax();
  }
  importIngredient(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-list/ingredient-list.ts